import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, IconButton, styled, Checkbox, useTheme, Skeleton } from "@mui/material";
import alignCenter from "assets/icons/aligncenter.svg";
import moment from "moment";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useGetInvoiceDueQuery } from "store/slices/apis/costSlice";
import { useParams } from "react-router-dom";


const StyledTableHead = styled(TableCell)({
    fontWeight: 500,
    fontSize: "14px",
    color: "#505258",
    padding: "8px 10px",
    backgroundColor: "#F8F8F8",
    border: "1px solid #D8D8D8",
    textAlign: "center",
    whiteSpace: "nowrap",
    letterSpacing: "-0.2px",
    lineHeight: "20px",
});

const StyledTableBody = styled(TableCell)({
    fontWeight: 400,
    fontSize: "14px",
    color: "#5052588A",
    padding: "8px 10px",
    backgroundColor: "#fff",
    border: "1px solid #D8D8D8",
    textAlign: "center",
    lineHeight: "20px",
    letterSpacing: "-0.2px",
    whiteSpace: "nowrap",
});

const StyledSkeletonCell = styled(TableCell)({
    padding: "10px 14px",
    border: "1px solid #D8D8D8",
    textAlign: "center",
    backgroundColor: "#fff",
});


const data = [
    {
        "activity": "INV-1001",
        "category": "Engineering",
        "baseline": "2025-03-20",
        "forecast": "2025-04-19",
        "amount": "₹844272"
    },
    {
        "activity": "INV-1002",
        "category": "Civil",
        "baseline": "2025-03-14",
        "forecast": "2025-04-13",
        "amount": "₹673867"
    },
    {
        "activity": "INV-1003",
        "category": "Engineering",
        "baseline": "2025-02-04",
        "forecast": "2025-03-06",
        "amount": "₹647135"
    },
    {
        "activity": "INV-1004",
        "category": "Civil",
        "baseline": "2025-02-21",
        "forecast": "2025-03-23",
        "amount": "₹796171"
    },
    {
        "activity": "INV-1005",
        "category": "Civil",
        "baseline": "2025-02-06",
        "forecast": "2025-03-08",
        "amount": "₹976906"
    },
    {
        "activity": "INV-1006",
        "category": "Fire Fighting",
        "baseline": "2025-02-09",
        "forecast": "2025-03-11",
        "amount": "₹910704"
    },
    {
        "activity": "INV-1007",
        "category": "HVAC",
        "baseline": "2025-04-01",
        "forecast": "2025-05-01",
        "amount": "₹813559"
    },
    {
        "activity": "INV-1008",
        "category": "Fire Fighting",
        "baseline": "2025-03-10",
        "forecast": "2025-04-09",
        "amount": "₹767333"
    },
    {
        "activity": "INV-1009",
        "category": "HVAC",
        "baseline": "2025-03-09",
        "forecast": "2025-04-08",
        "amount": "₹482764"
    },
    {
        "activity": "INV-1010",
        "category": "Engineering",
        "baseline": "2025-03-01",
        "forecast": "2025-03-31",
        "amount": "₹1063705"
    },
    {
        "activity": "INV-1011",
        "category": "Engineering",
        "baseline": "2025-02-02",
        "forecast": "2025-03-04",
        "amount": "₹494471"
    },
    {
        "activity": "INV-1012",
        "category": "Civil",
        "baseline": "2025-03-07",
        "forecast": "2025-04-06",
        "amount": "₹532339"
    },
    {
        "activity": "INV-1013",
        "category": "Fire Fighting",
        "baseline": "2025-02-11",
        "forecast": "2025-03-13",
        "amount": "₹1114364"
    },
    {
        "activity": "INV-1014",
        "category": "HVAC",
        "baseline": "2025-02-13",
        "forecast": "2025-03-15",
        "amount": "₹1060590"
    },
    {
        "activity": "INV-1015",
        "category": "HVAC",
        "baseline": "2025-03-20",
        "forecast": "2025-04-19",
        "amount": "₹1017446"
    },
    {
        "activity": "INV-1016",
        "category": "Fire Fighting",
        "baseline": "2025-02-01",
        "forecast": "2025-03-03",
        "amount": "₹1129571"
    },
    {
        "activity": "INV-1017",
        "category": "HVAC",
        "baseline": "2025-02-06",
        "forecast": "2025-03-08",
        "amount": "₹774910"
    },
    {
        "activity": "INV-1018",
        "category": "HVAC",
        "baseline": "2025-03-12",
        "forecast": "2025-04-11",
        "amount": "₹385274"
    },
    {
        "activity": "INV-1019",
        "category": "Engineering",
        "baseline": "2025-03-09",
        "forecast": "2025-04-08",
        "amount": "₹1196588"
    },
    {
        "activity": "INV-1020",
        "category": "HVAC",
        "baseline": "2025-03-05",
        "forecast": "2025-04-04",
        "amount": "₹1174472"
    },
    {
        "activity": "INV-1021",
        "category": "Engineering",
        "baseline": "2025-03-17",
        "forecast": "2025-04-16",
        "amount": "₹457239"
    },
    {
        "activity": "INV-1022",
        "category": "HVAC",
        "baseline": "2025-03-04",
        "forecast": "2025-04-03",
        "amount": "₹364766"
    },
    {
        "activity": "INV-1023",
        "category": "HVAC",
        "baseline": "2025-02-28",
        "forecast": "2025-03-30",
        "amount": "₹987961"
    },
    {
        "activity": "INV-1024",
        "category": "HVAC",
        "baseline": "2025-02-14",
        "forecast": "2025-03-16",
        "amount": "₹294258"
    },
    {
        "activity": "INV-1025",
        "category": "Civil",
        "baseline": "2025-03-11",
        "forecast": "2025-04-10",
        "amount": "₹786730"
    },
    {
        "activity": "INV-1026",
        "category": "Engineering",
        "baseline": "2025-03-12",
        "forecast": "2025-04-11",
        "amount": "₹557200"
    },
    {
        "activity": "INV-1027",
        "category": "HVAC",
        "baseline": "2025-03-28",
        "forecast": "2025-04-27",
        "amount": "₹302049"
    },
    {
        "activity": "INV-1028",
        "category": "Engineering",
        "baseline": "2025-02-06",
        "forecast": "2025-03-08",
        "amount": "₹613857"
    },
    {
        "activity": "INV-1029",
        "category": "Civil",
        "baseline": "2025-03-16",
        "forecast": "2025-04-15",
        "amount": "₹383294"
    },
    {
        "activity": "INV-1030",
        "category": "Fire Fighting",
        "baseline": "2025-02-18",
        "forecast": "2025-03-20",
        "amount": "₹630564"
    }
];

const InvoiceList = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const theme = useTheme();
    const { projectId } = useParams();
    const invoiceList = useGetInvoiceDueQuery({ projectId });




    if (invoiceList?.isLoading) {
        return (
            <Paper
                sx={{
                    boxShadow: "none",
                    marginTop: "20px",
                    paddingBottom: "18px",
                    borderRadius: "5px",
                    minHeight: "400px",
                }}
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {[...Array(4)].map((_, i) => (
                                    <StyledSkeletonCell key={i}>
                                        <Box sx={{ py: 2 }}>
                                            <Skeleton
                                                variant="rectangular"
                                                width={i === 0 ? 20 : 80}
                                                height={15}
                                            />
                                        </Box>
                                    </StyledSkeletonCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[...Array(6)].map((_, index) => (
                                <TableRow key={index}>
                                    {[...Array(4)].map((_, i) => (
                                        <StyledSkeletonCell key={i}>
                                            <Box sx={{ py: 1 }}>
                                                <Skeleton
                                                    variant={i === 0 ? "circular" : "text"}
                                                    width={i === 0 ? 18 : "90%"}
                                                    height={20}
                                                />
                                            </Box>
                                        </StyledSkeletonCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        );
    }

    const rowsPerPage = 6;
    const totalPages = Math.ceil(invoiceList?.data?.data?.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const currentRows = invoiceList?.data?.data?.slice(startIndex, endIndex);

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: "450px",
                    border: "1px solid #2525252E",
                    mt: 0,
                    mb: 0,
                    borderRadius: "7px",
                    overflow: "hidden",
                    backgroundColor: "white",
                    position: "relative",

                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            fontSize: "18px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: `${theme?.customSettings?.themeColor}`,
                        }}
                    >
                        Invoices due this month
                    </Typography>
                    <Typography
                        sx={{
                            mt: "8px",
                            color: "#5052588A",
                            fontSize: "14px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                        }}
                    >
                        Monitor financial obligations to ensure timely clearances and maintain cash flow control
                    </Typography>
                </Box>
                <TableContainer sx={{ mt: "24px" }}>
                    <Table sx={{ width: "100%", border: "1px solid #D8D8D8", }}>
                        <TableHead>
                            <TableRow>
                                {["Invoice", "Invoice Date", "Due Date", "Amount"].map(
                                    (header) => (
                                        <StyledTableHead key={header}>{header}</StyledTableHead>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoiceList?.data?.data?.length === 0 ? (
                                <TableRow>
                                    <TableCell
                                        colSpan={4}
                                        align="center"
                                        sx={{ py: 4, color: "#999", fontSize: "16px" }}
                                    >
                                        No record found.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                currentRows.map((row, index) => (
                                    <TableRow key={index}>
                                        <StyledTableBody>
                                            {row?.invoiceNumber}
                                        </StyledTableBody>
                                        <StyledTableBody>{moment(row.invoiceDate)?.format('DD-MM-YYYY')}</StyledTableBody>
                                        <StyledTableBody>{moment(row.invoiceDueDate)?.format('DD-MM-YYYY')}</StyledTableBody>
                                        <StyledTableBody>{`₹${row.invoiceAmount}`}</StyledTableBody>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box
                    sx={{
                        position: "absolute",
                        mb: "10px",
                        right: 0,
                        mt: 0,
                        padding: "12px 16px",
                        backgroundColor: "#fff",
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    {/* {!isLoading && ( */}
                    <PaginationComponent
                        pageNumber={currentPage}
                        totalPages={totalPages || 1}
                        onPageChange={setCurrentPage}
                    />
                    {/* )} */}
                </Box>
            </Box>

        </>
    );
};

export default InvoiceList;
